export const QuickAddPanel = {
  flow: 'y',
  state: {
    type: 'components'
  },
  tag: 'form',
  gap: 'Z',
  onSubmit: (ev, el, s) => {
    ev.preventDefault()
    el.call('createItem', s.type, s.key)
  },
  CaptionTitle: {
    Text: {
      text: '{{ editor.quickAdd.title | polyglot }}'
    }
  },
  Flex: {
    gap: 'X',
    margin: '- - - -Z+W',
    Select_action: {
      background: 'none',
      color: 'currentColor',
      padding: 'X Y2',
      width: 'D3',
      onChange: (ev, el, s, ctx) => {
        const value = ev.target.value
        if (value) {
          s.update({
            action: value
          })
        }
      },
      children: [
        {
          text: '{{ common.action.create | polyglot }}',
          value: 'create'
        },
        {
          text: '{{ editor.quickAdd.reuse | polyglot }}',
          value: 'reuse'
        },
        {
          text: '{{ common.action.duplicate | polyglot }}',
          value: 'duplicate'
        }
      ],
      childrenAs: 'props',
      childProps: {
        tag: 'option',
        attr: {
          selected: (el, s) => el.node.value === s.action
        }
      }
    },
    Select_type: {
      background: 'none',
      color: 'currentColor',
      padding: 'X Y2',
      width: 'E+A',
      onChange: (ev, el, s, ctx) => {
        const value = ev.target.value
        if (value) {
          s.update({
            type: value
          })
        }
      },
      children: [
        {
          text: '{{ editor.quickAdd.component | polyglot }}',
          value: 'components'
        },
        {
          text: '{{ editor.quickAdd.page | polyglot }}',
          value: 'pages'
        },
        {
          text: '{{ editor.addFunction.name | polyglot }}',
          value: 'functions'
        },
        {
          text: '{{ editor.quickAdd.method | polyglot }}',
          value: 'methods'
        },
        {
          text: '{{ editor.panel.state | polyglot }}',
          value: 'state'
        },
        {
          text: '{{ editor.quickAdd.dependency | polyglot }}',
          value: 'dependencies'
        }
      ],
      childrenAs: 'props',
      childProps: {
        tag: 'option',
        attr: {
          selected: (el, s) => el.node.value === s.action
        }
      }
    },
    FileSidebarAddNewItem: {
      Label: {
        border: 'none',
        '.hasItems': null,
        margin: '0',
        Icon: null,
        Input: {
          padding: 'Z',
          required: true,
          // FLAT prop, not `attr: {}` (FA105): an attribute needs the FUNCTION
          // form to switch language, and `{example}` is the identifier SHAPE
          // the field accepts — never translated (glossary rule 5).
          placeholder: (el, s) =>
            el
              .call('polyglot', 'editor.quickAdd.typePlaceholder')
              .replace('{example}', el.scope.EXAMPLE_BY_TYPE[s.type] || ''),
          scope: {
            EXAMPLE_BY_TYPE: {
              pages: '/page-path',
              components: 'ComponentName',
              functions: 'functionName',
              methods: 'methodName',
              state: 'state_name',
              secrets: 'secret_name',
              dependencies: '@dep/name'
            }
          }
        },
        Flex: {
          margin: '- - - auto',
          Save: {
            extends: 'NavbarButton'
          },
          Close: null
        }
      },
      flex: 1
    }
  }
}
